import { PropsWithChildren, useState } from "react";

import { StyleProp, View, ViewStyle } from "react-native";
import { IconButton, useTheme } from "react-native-paper";

import Modal from "../Modal";
import QRCodeWebView from "./QRCodeWebView";
import useModalContext from "../Modal/ModalContext";

type CodeProps = {
  url: string;
  size?: number;
  utm_campaign?: string;
};

function QRCode({ size = 200, url, utm_campaign }: CodeProps) {
  return (
    <View style={{ height: size, width: size }} pointerEvents="none">
      <QRCodeWebView url={withUTMs(url, utm_campaign)} />
    </View>
  );
}

type ModalProps = PropsWithChildren<{ style?: StyleProp<ViewStyle> }>;
function QRModal({ style, children }: ModalProps) {
  const { colors } = useTheme();
  const modal = useModalContext();

  const [visible, setVisible] = useState(false);

  function dismiss() {
    setVisible(false);
    modal.dismiss();
  }

  function show() {
    setVisible(true);
    modal.show();
  }

  return (
    <View>
      <Modal
        visible={visible}
        onDismiss={dismiss}
        showClose
        contentContainerStyle={style}
      >
        {children}
      </Modal>

      <IconButton
        icon="qrcode-scan"
        mode="contained-tonal"
        onPress={show}
        iconColor={colors.onSecondaryContainer}
        containerColor={colors.secondaryContainer}
      />
    </View>
  );
}

export default {
  Code: QRCode,
  Modal: QRModal,
};

function withUTMs(originalUrl: string, utm_campaign?: string) {
  let url = `${originalUrl}?utm_source=mobile-app&utm_medium=qr`;
  if (utm_campaign) {
    url += `&utm_campaign=${utm_campaign}`;
  }
  return url;
}
